import React from "react";
import "./TutorRequestFlow/Lesson/Lesson.css";
import Detail from "./TutorRequestFlow/Lesson/LessonDetails";
import Lessonrequirements from "./TutorRequestFlow/Lesson/LessonRequirements";
import Lessonsummary from "./TutorRequestFlow/Lesson/LessonSummary";
import Questions from "./TutorRequestFlow/Lesson/Questions";
import "bootstrap/dist/css/bootstrap.css";

const lessonDetails = (props) => {
  return (
    <section className="container">
      <div className="Lesson-Col">
        <div className="right-side-panel" style={{ border: "none" }}>
          <Detail />
          <Lessonrequirements />
          <Lessonsummary />
          <Questions />
        </div>
      </div>
    </section>
  );
};
export default lessonDetails;
